/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TgRouteImport } from './routes/_tg'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PendingApprovalRouteImport } from './routes/pending-approval'
import { Route as RecoverPasswordRouteImport } from './routes/recover-password'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as TgIndexRouteImport } from './routes/_tg/index'
import { Route as TgAdminRouteImport } from './routes/_tg/admin'
import { Route as TgSettingsRouteImport } from './routes/_tg/settings'
import { Route as TgSummarizerRouteImport } from './routes/_tg/summarizer'
import { Route as TgWorkspaceRouteImport } from './routes/_tg/workspace'

const TgRoute = TgRouteImport.update({
  id: '/_tg',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PendingApprovalRoute = PendingApprovalRouteImport.update({
  id: '/pending-approval',
  path: '/pending-approval',
  getParentRoute: () => rootRouteImport,
} as any)
const RecoverPasswordRoute = RecoverPasswordRouteImport.update({
  id: '/recover-password',
  path: '/recover-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const TgIndexRoute = TgIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TgRoute,
} as any)
const TgAdminRoute = TgAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => TgRoute,
} as any)
const TgSettingsRoute = TgSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => TgRoute,
} as any)
const TgSummarizerRoute = TgSummarizerRouteImport.update({
  id: '/summarizer',
  path: '/summarizer',
  getParentRoute: () => TgRoute,
} as any)
const TgWorkspaceRoute = TgWorkspaceRouteImport.update({
  id: '/workspace',
  path: '/workspace',
  getParentRoute: () => TgRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof TgIndexRoute
  '/login': typeof LoginRoute
  '/pending-approval': typeof PendingApprovalRoute
  '/recover-password': typeof RecoverPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/admin': typeof TgAdminRoute
  '/settings': typeof TgSettingsRoute
  '/summarizer': typeof TgSummarizerRoute
  '/workspace': typeof TgWorkspaceRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/pending-approval': typeof PendingApprovalRoute
  '/recover-password': typeof RecoverPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/admin': typeof TgAdminRoute
  '/settings': typeof TgSettingsRoute
  '/summarizer': typeof TgSummarizerRoute
  '/workspace': typeof TgWorkspaceRoute
  '/': typeof TgIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_tg': typeof TgRouteWithChildren
  '/login': typeof LoginRoute
  '/pending-approval': typeof PendingApprovalRoute
  '/recover-password': typeof RecoverPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/_tg/admin': typeof TgAdminRoute
  '/_tg/settings': typeof TgSettingsRoute
  '/_tg/summarizer': typeof TgSummarizerRoute
  '/_tg/workspace': typeof TgWorkspaceRoute
  '/_tg/': typeof TgIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/pending-approval'
    | '/recover-password'
    | '/reset-password'
    | '/signup'
    | '/admin'
    | '/settings'
    | '/summarizer'
    | '/workspace'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/pending-approval'
    | '/recover-password'
    | '/reset-password'
    | '/signup'
    | '/admin'
    | '/settings'
    | '/summarizer'
    | '/workspace'
    | '/'
  id:
    | '__root__'
    | '/_tg'
    | '/login'
    | '/pending-approval'
    | '/recover-password'
    | '/reset-password'
    | '/signup'
    | '/_tg/admin'
    | '/_tg/settings'
    | '/_tg/summarizer'
    | '/_tg/workspace'
    | '/_tg/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  TgRoute: typeof TgRouteWithChildren
  LoginRoute: typeof LoginRoute
  PendingApprovalRoute: typeof PendingApprovalRoute
  RecoverPasswordRoute: typeof RecoverPasswordRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_tg': {
      id: '/_tg'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof TgRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pending-approval': {
      id: '/pending-approval'
      path: '/pending-approval'
      fullPath: '/pending-approval'
      preLoaderRoute: typeof PendingApprovalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recover-password': {
      id: '/recover-password'
      path: '/recover-password'
      fullPath: '/recover-password'
      preLoaderRoute: typeof RecoverPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_tg/': {
      id: '/_tg/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof TgIndexRouteImport
      parentRoute: typeof TgRoute
    }
    '/_tg/admin': {
      id: '/_tg/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof TgAdminRouteImport
      parentRoute: typeof TgRoute
    }
    '/_tg/settings': {
      id: '/_tg/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof TgSettingsRouteImport
      parentRoute: typeof TgRoute
    }
    '/_tg/summarizer': {
      id: '/_tg/summarizer'
      path: '/summarizer'
      fullPath: '/summarizer'
      preLoaderRoute: typeof TgSummarizerRouteImport
      parentRoute: typeof TgRoute
    }
    '/_tg/workspace': {
      id: '/_tg/workspace'
      path: '/workspace'
      fullPath: '/workspace'
      preLoaderRoute: typeof TgWorkspaceRouteImport
      parentRoute: typeof TgRoute
    }
  }
}

interface TgRouteChildren {
  TgAdminRoute: typeof TgAdminRoute
  TgSettingsRoute: typeof TgSettingsRoute
  TgSummarizerRoute: typeof TgSummarizerRoute
  TgWorkspaceRoute: typeof TgWorkspaceRoute
  TgIndexRoute: typeof TgIndexRoute
}

const TgRouteChildren: TgRouteChildren = {
  TgAdminRoute: TgAdminRoute,
  TgSettingsRoute: TgSettingsRoute,
  TgSummarizerRoute: TgSummarizerRoute,
  TgWorkspaceRoute: TgWorkspaceRoute,
  TgIndexRoute: TgIndexRoute,
}

const TgRouteWithChildren = TgRoute._addFileChildren(TgRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  TgRoute: TgRouteWithChildren,
  LoginRoute: LoginRoute,
  PendingApprovalRoute: PendingApprovalRoute,
  RecoverPasswordRoute: RecoverPasswordRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
